<template>
    <MiniBetSlip
        class="MiniParlaySlip_expand"
        v-bind:count="ticketCount"
        v-bind:title="comboParlaySelection"
        v-bind:odds="oddsDisplay"
        v-bind:maxPayout="totalPayoutDisplay"
        v-on:click="showMediumBetSlip"
    />
</template>

<script setup lang="ts">
    import { storeToRefs } from 'pinia';
    import { computed } from 'vue';
    import MiniBetSlip from '@/components/betSlip/MiniBetSlip.vue';
    import { useBetSlipStore } from '@/stores/betSlip/betSlipStore';
    import { useParlayBetSlipStore } from '@/stores/betSlip/parlayBetSlipStore';

    const { showMediumBetSlip } = useBetSlipStore();

    const {
        ticketCount,
        totalOdds,
        totalOddsDisplay,
        totalPayoutDisplay,
        comboParlaySelection,
    } = storeToRefs(useParlayBetSlipStore());

    const oddsDisplay = computed(() => (totalOdds.value > 0 ? totalOddsDisplay.value : ''));

    const { refresh } = useParlayBetSlipStore();
    refresh(true);
</script>
